import { render, staticRenderFns } from "./AnimatedMail.vue?vue&type=template&id=386e7c22&scoped=true"
import script from "./AnimatedMail.vue?vue&type=script&lang=js"
export * from "./AnimatedMail.vue?vue&type=script&lang=js"
import style0 from "./AnimatedMail.vue?vue&type=style&index=0&id=386e7c22&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "386e7c22",
  null
  
)

export default component.exports